import React from 'react'

function VATStatus(status) {
  return(
    <React.Fragment>
        {status == "ANEW" && <span className="badge badge-primary">MỚI</span>}
        {status == "BDELAY" && <span className="badge badge-danger">CHỜ XUẤT</span>}
        {status == "CPROCESS" && <span className="badge badge-warning">TIẾN HÀNH XUẤT</span>}
        {status == "DFINISH" && <span className="badge bg-success">HOÀN TẤT</span>}
    </React.Fragment>
  )
}

export default VATStatus;